import { Group, Button, TextInput, TextInputProps, TagsInput, TagsInputProps } from "@mantine/core";
import { useForm, schemaResolver } from "@mantine/form";
import { ContextModalProps } from "@mantine/modals";
import { z } from 'zod';

interface TagsInputModalProps {
    initTags?: string[],
    children?: React.ReactNode;
    tagsInputProps?: TagsInputProps,
    confirmLabel?: string,
    zodString?: z.ZodString,
    onConfirm?: (value: string[]) => void;
}
export const TagsInputModal = ({
    context,
    id,
    innerProps,
}: ContextModalProps<TagsInputModalProps>) => {
    const schema = z.object({
        tags: innerProps.zodString ?? z.string().array()
    });
    const form = useForm({
        validate: schemaResolver(schema),
        initialValues: {
            tags: innerProps.initTags
        },
    });
    return <>
        {innerProps.children}
        <form onSubmit={form.onSubmit((values) => {
            innerProps.onConfirm?.(values.tags ?? []);
            context.closeModal(id)
        })}>
            <TagsInput
                {...innerProps.tagsInputProps}
                {...form.getInputProps('tags')}
            />
            <Group justify="flex-end" mt="md">
                <Button type="submit">{innerProps.confirmLabel || "確認"}</Button>
            </Group>
        </form>
    </>
}